import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const DEVELOPMENT_MODE_STORAGE_KEY = 'development_mode_active';

@Injectable({
  providedIn: 'root'
})
export class DevelopmentModeService {
  private readonly activeState = new BehaviorSubject<boolean>(this.readInitialState());
  public readonly active$: Observable<boolean> = this.activeState.asObservable();

  isActive(): boolean {
    return this.activeState.value;
  }

  setActive(active: boolean): void {
    this.activeState.next(active);
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(DEVELOPMENT_MODE_STORAGE_KEY, JSON.stringify(active));
  }

  private readInitialState(): boolean {
    if (typeof localStorage === 'undefined') return false;
    const stored = localStorage.getItem(DEVELOPMENT_MODE_STORAGE_KEY);
    if (!stored) return false;

    try {
      return JSON.parse(stored) === true;
    } catch {
      return false;
    }
  }
}
